import { getRawId } from 'util/globalId'
import { selectDraftById } from 'ducks/drafts2/selectors'
import { startTimer } from './actions'
import { selectCurrentUndoSendDelay } from './selectors'

const extractUndoParams = response => {
  if (!response) return null
  let data = null
  ;[
    'conversationCreateEmail',
    'conversationForwardV2',
    'conversationReply',
  ].forEach(key => {
    if (
      response[key] &&
      response[key].conversation &&
      response[key].conversation.id &&
      response[key].changesetId
    ) {
      data = {
        ticketId: response[key].conversation.id,
        changesetId: response[key].changesetId,
      }
    }
  })
  return data
}

export const withUndoSend = (draftId, action) => async (dispatch, getState) => {
  const state = getState()
  const draft = selectDraftById(state, draftId)
  const undoSendDelay = selectCurrentUndoSendDelay(state)

  const response = await dispatch(action)
  const params = extractUndoParams(response)
  if (!params || undoSendDelay === 0) return response

  const { ticketId, changesetId } = params
  dispatch(startTimer({ ticketId: getRawId(ticketId), changesetId, draft }))
  return response
}
